import { render, staticRenderFns } from "./CreateMunicipalOrder.vue?vue&type=template&id=59facd4b&scoped=true&"
import script from "./CreateMunicipalOrder.vue?vue&type=script&lang=js&"
export * from "./CreateMunicipalOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateMunicipalOrder.vue?vue&type=style&index=0&id=59facd4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59facd4b",
  null
  
)

export default component.exports